@if (!multiple) {
  <mat-form-field class="mat-form-field mat-custom w-100 picker" appearance="fill">
    <input
      matInput
      [required]="required"
      placeholder="{{ placeholderTranslationKey | translate }}"
      [value]="getProjectInputValue()"
      readonly
      />
    @if (!readonly) {
      @if (!projects.length) {
        <ceres-button (click)="openProjectSelection()" [layout]="'picker'">
          <i class="material-icons">add</i>
        </ceres-button>
      } @else {
        <ceres-button (click)="removeSelected()" [layout]="'picker'">
          <i class="material-icons">delete</i>
        </ceres-button>
      }
    }
  </mat-form-field>
} @else {
  <mat-form-field class="w-100">
    <mat-chip-list #chipList>
      @for (project of projects; track project) {
        <mat-chip (removed)="removeSelected(project)">
          {{ project.mpTitle }}
          @if (!readonly) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip>
      }
      @if (!readonly) {
        <mat-chip (click)="openProjectSelection()">
          <mat-icon>add</mat-icon>
        </mat-chip>
      }
      <input
        [disabled]="readonly"
        [matChipInputFor]="chipList"
        placeholder="{{ placeholderTranslationKey || translate }}"
        readonly
        />
    </mat-chip-list>
  </mat-form-field>
}
